import { AfterViewInit, Component, ViewChild, ViewContainerRef, Input } from "@angular/core";

import { ICellEditorAngularComp, AgRendererComponent } from "ag-grid-angular";
// import * as moment from 'moment'
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
// import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";


@Component({
    selector: 'ixsprogressbar',
//     template: `<div class="progress">
//   <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="value"
//   aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': value + '%'}" style="margin-top: 3px; border-radius: 10px">
//     {{value}}%
//   </div>
// </div>`,

template: `<div class="progress" *ngIf=" type === 1" style="height: 17px;margin-bottom: 0px;margin-top: 4px;">
  <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="value"
  aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': value + '%'}">
    {{value}}%
  </div>
</div>

<div class="progress" *ngIf=" type === 2" style="margin-bottom: auto;height: 11px;">
  <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="value"
  aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': value + '%'}" style="/* margin-top: 3px; */border-radius: 10px;width: 100%;font-size: 11px;line-height: 10px;">
    {{value}}%
  </div>
</div>`,

})
export class IxsprogressbarComponent {



    private _value: number;
    @Input()
    set value(val: number) {
        this._value = val;
    }
    get value(): number {
        return this._value
    }



    _type: number = 1

    @Input()
    set type(type: number) {
        this._type = type;
    }
    get type(): number {
        return this._type
    }
















}


// WEBPACK FOOTER //
// ./src/app/components/ixsprogressbar/ixsprogressbar.component.ts